import { render } from "./Whitelist.vue?vue&type=template&id=58d63889&scoped=true"
import script from "./Whitelist.vue?vue&type=script&lang=js"
export * from "./Whitelist.vue?vue&type=script&lang=js"

import "./Whitelist.vue?vue&type=style&index=0&id=58d63889&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58d63889"]])

export default __exports__